export default "__VITE_ASSET__DU6pg8a$__"